import React from 'react'
import { Link } from 'react-router'
import Appbar from 'muicss/lib/react/appbar'
import Container from 'muicss/lib/react/container'
import IcoBag from 'react-icons/lib/io/bag'
import IcoFlag from 'react-icons/lib/io/flag'

const Header = ({disableLink}) => {
  const vIcon = !disableLink ?  (
    <Link to="/">
        <img src="/img/selects-round-logo.svg" alt="S" height="32px" width="32px" />
    </Link>) :(
      <img src="/img/selects-round-logo.svg" alt="S" height="32px" width="32px" />
    )

  return (
    <header id="header">
        <Appbar className="mui--z0">
            <Container>
                <table width="100%">
                    <tbody>
                        <tr className="mui--appbar-height">
                            <td>
                                {vIcon}
                            </td>
                            <td className="mui--text-right">
                                <ul className="mui-list--inline header-menu">
                                    {/* <li><Link to="/featured"><IcoFlag />特集</Link></li> */}
                                    {/* <li data-badge="12"><Link to="/mylist"><IcoBag />マイリスト</Link></li> */}
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Container>
        </Appbar>
    </header>
  )}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js